module.exports = __webpack_public_path__ + "static/media/trailer-2.fcbb80d9.png";